// import { configureStore } from "@reduxjs/toolkit";
// import driverSlice from "./driverSlice";
// import productSlice from "./productSlice";
// import vendorSlice from "./vendorSlice";
// import stockSlice from "./stockSlice";
// import dplistSlice from "./dplistSlice";

// const store = configureStore({
//   reducer: {
//     drivers: driverSlice,
//     products: productSlice,
//     vendors: vendorSlice,
//     stocks: stockSlice,
//     dplist: dplistSlice,
//   },
// });

// export default store;

import { configureStore } from "@reduxjs/toolkit";
import driverSlice from "./driverSlice";
import productSlice from "./productSlice";
import vendorSlice from "./vendorSlice";
import stockSlice from "./stockSlice";
import dplistSlice from "./dplistSlice";
import godownSlice from "./godownSlice";
import vehiclSlice from "./vehiclSlice";
import customerSlice from "./customerSlice";
import orderSlice from "./orderSlice";
import receiptReducer from "./receiptSlice";
import inventorySlice from "./inventorySlice";
import purchaseSlice from "./purchaseSlice";
import quotationReducer from "./quotationSlice";
import purchaseReducer from "./purchaseOrderSlice"
import bankReducer from "./bankSlice";
import bankReportReducer from "./bankReportSlice";

const store = configureStore({
  reducer: {
    drivers: driverSlice,
    products: productSlice,
    vendors: vendorSlice,
    stocks: stockSlice,
    dplist: dplistSlice,
    godown: godownSlice,
    vehicles: vehiclSlice,
    customers: customerSlice,
    orders: orderSlice,
    inventory: inventorySlice,
    purchase: purchaseSlice,
    receipt: receiptReducer, 
    quotation:quotationReducer,
    purchaseOrder:purchaseReducer,
    banks:bankReducer,
    bankReports:bankReportReducer,
  },
});

export default store;
